import { Text } from 'components/_temp_ui_common/theme/Text';
import { preferredName } from 'components/_temp_ui_common/utilities/preferredName';
import { Bendie, BendieAnimation, Motion } from 'components/bendies/Bendie';
import { useConsult } from 'contexts/ConsultContext';
import { useCurrentUser } from 'contexts/CurrentUserContext';
import { FC } from 'react';

interface Props {
  isReferral: boolean | null;
  referringName?: string | null;
}

export const AgreementsIntroPanel: FC<Props> = ({
  isReferral,
  referringName,
}) => {
  const user = useCurrentUser();
  const consultContext = useConsult();
  const username = user.state.account?.firstName;
  const membername = preferredName(consultContext.consult?.patient);

  if (!user.state.account || !consultContext.consult) return null;

  if (isReferral === false) {
    return (
      <div className="bend-agreements-container">
        <p>
          <Text variant="h3">Bend Health Care Agreements</Text>
        </p>
        <p className="please-review-copy">
          <Text variant="body-4">
            Please review and agree to the following to continue:
          </Text>
        </p>
      </div>
    );
  }

  if (isReferral === true) {
    return (
      <div className="bend-agreements-container">
        <div
          className="bendie-container"
          style={{ height: 150, position: 'relative' }}
        >
          <svg
            style={{ position: 'absolute', bottom: 0 }}
            xmlns="http://www.w3.org/2000/svg"
            width="140"
            height="141"
            viewBox="0 0 140 141"
            fill="none"
          >
            <circle cx="70" cy="70.5" r="70" fill="#6471B4" />
          </svg>
          <BendieAnimation
            bendie={Bendie.Hal}
            motion={Motion.Dance}
            style={{ height: 200, width: 150, position: 'absolute', top: -30 }}
          />
        </div>
        <Text variant="h3">Welcome, {username}!</Text>
        <Text variant="body-4" block>
          <br />
          Thank you for accepting {membername}’s referral from {referringName}.
          We’re so glad you’re here.
        </Text>
        <br />
        <Text variant="body-4" block>
          To get started with care, please complete the following:
        </Text>
        <br />
        <p>
          <ul className="decorated">
            <li>
              <Text variant="body-4">Review and accept legal agreements</Text>
            </li>
            <li>
              <Text variant="body-4">Complete symptom assessment</Text>
            </li>
            <li>
              <Text variant="body-4">Schedule first appointment</Text>
            </li>
          </ul>
        </p>
      </div>
    );
  }
  return null;
};
